import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import VatSummaryBar from './VatSummaryBar';
import VatTrendChart from './VatTrendChart';
import VatCategoryBarChart from './VatCategoryBarChart';
import { useTranslatedMessages } from '../../../../hooks/useTranslatedMessages';

const VatTab = ({ vatData, loading = false }) => {
  const { misDashboard: m } = useTranslatedMessages();

  if (!loading && !vatData) {
    return (
      <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
        <Typography color="text.secondary">
          {m.vat?.no_data ?? 'No VAT data available for the selected filters.'}
        </Typography>
      </Paper>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <VatSummaryBar summary={vatData?.summary} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <VatTrendChart trend={vatData?.trend ?? []} loading={loading} />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <VatCategoryBarChart categories={vatData?.by_vat_category ?? []} loading={loading} />
      </Grid>
    </Grid>
  );
};

export default VatTab;
